"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoryApiCredentials = void 0;
var tslib_1 = require("tslib");
var MemoryApiCredentials = /** @class */ (function () {
    function MemoryApiCredentials() {
        this.delegateUser = null;
        this.delegateCompany = null;
        this.tokens = {
            accessToken: '',
            refreshToken: '',
            exchangeToken: '',
        };
    }
    MemoryApiCredentials.prototype.getTokens = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, accessToken, refreshToken, exchangeToken;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.getAccessToken(),
                            this.getRefreshToken(),
                            this.getExchangeToken(),
                        ])];
                    case 1:
                        _a = _b.sent(), accessToken = _a[0], refreshToken = _a[1], exchangeToken = _a[2];
                        return [2 /*return*/, { accessToken: accessToken, refreshToken: refreshToken, exchangeToken: exchangeToken }];
                }
            });
        });
    };
    MemoryApiCredentials.prototype.getAccessToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.tokens.accessToken];
            });
        });
    };
    MemoryApiCredentials.prototype.getRefreshToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.tokens.refreshToken];
            });
        });
    };
    MemoryApiCredentials.prototype.getExchangeToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.tokens.exchangeToken];
            });
        });
    };
    MemoryApiCredentials.prototype.setDelegateCompany = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.delegateCompany = id;
                return [2 /*return*/];
            });
        });
    };
    MemoryApiCredentials.prototype.getDelegateCompany = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.delegateCompany];
            });
        });
    };
    MemoryApiCredentials.prototype.setDelegateUser = function (email) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.delegateUser = email;
                return [2 /*return*/];
            });
        });
    };
    MemoryApiCredentials.prototype.getDelegateUser = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.delegateUser];
            });
        });
    };
    MemoryApiCredentials.prototype.setTokens = function (token, refreshToken) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([this.setAccessToken(token), this.setRefreshToken(refreshToken)])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MemoryApiCredentials.prototype.setAccessToken = function (token) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.tokens.accessToken = token;
                return [2 /*return*/];
            });
        });
    };
    MemoryApiCredentials.prototype.setRefreshToken = function (token) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.tokens.refreshToken = token;
                return [2 /*return*/];
            });
        });
    };
    MemoryApiCredentials.prototype.setExchangeToken = function (token) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.tokens.exchangeToken = token;
                return [2 /*return*/];
            });
        });
    };
    MemoryApiCredentials.prototype.deleteTokens = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([this.deleteAccessToken(), this.deleteRefreshToken(), this.deleteExchangeToken()])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MemoryApiCredentials.prototype.deleteAccessToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.tokens.accessToken = '';
                return [2 /*return*/];
            });
        });
    };
    MemoryApiCredentials.prototype.deleteRefreshToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.tokens.refreshToken = '';
                return [2 /*return*/];
            });
        });
    };
    MemoryApiCredentials.prototype.deleteExchangeToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.tokens.exchangeToken = '';
                return [2 /*return*/];
            });
        });
    };
    MemoryApiCredentials.prototype.clear = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([this.setDelegateUser(null), this.setDelegateCompany(null), this.deleteTokens()])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return MemoryApiCredentials;
}());
exports.MemoryApiCredentials = MemoryApiCredentials;
